import { render, staticRenderFns } from "./dimline.vue?vue&type=template&id=71f67dd6&scoped=true"
import script from "./dimline.vue?vue&type=script&lang=js"
export * from "./dimline.vue?vue&type=script&lang=js"
import style0 from "./dimline.vue?vue&type=style&index=0&id=71f67dd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f67dd6",
  null
  
)

export default component.exports